export const presetSchema = {
  presets: [
    { name: "case1", title: "Personnel (map)" },
    { name: "case2", title: "Kentucky (multiples)" },
    { name: "case3", title: "Railways (line)" },
    { name: "case4", title: "Bookstores (bar)" },
    { name: "case5", title: "Server breaks (dot)" },
    { name: "case6", title: "Efficacy (tabular)" }
  ]
}
export const presetNames = presetSchema.presets.map(d => d.name);
export let presetMap = {};
presetSchema.presets.forEach(d => {
  presetMap[d.name] = d.title
});